import React from "react";
import { trackEvent, trackButtonClick } from "utils/analytics";

function Slot({
  date,
  reservationRequest,
  deleteReservationRequest,
  practitioner,
  reason,
  startTime,
  doesMatching,
  updateItem,
  practiceId,
  reservationKey,
  themeColor,
  anyBatch,
}) {
  let params = {};
  if (doesMatching) {
    params = {
      reasonId: reason.id,
      practitionerId: practitioner.id,
      date,
      reservationKey,
      anyBatch,
    };
  } else {
    params = {
      reasonId: reason.id,
      practitionerId: practitioner.id,
      date,
      startTime,
      reservationKey,
      anyBatch,
    };
  }

  const bgColor = themeColor || '#000';

  return (
    <div
      onClick={() => {
        if (doesMatching) {
          deleteReservationRequest(params, practiceId);
          trackEvent("time_slot_deselected", { start_time: startTime, date });
          trackButtonClick('time_slot_deselect', { time: startTime, date });
        } else {
          reservationRequest(params, practiceId);
          trackEvent("time_slot_selected", {
            start_time: startTime,
            date,
            practitioner_id: practitioner?.id,
            practitioner_name: practitioner?.name,
            service_id: reason?.id,
            service_name: reason?.name,
          });
          trackButtonClick('time_slot_select', { time: startTime, date });
        }
      }}
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '10px 8px',
        borderRadius: 6,
        cursor: 'pointer',
        background: doesMatching ? bgColor : '#fff',
        color: doesMatching ? '#fff' : bgColor,
        border: `1.5px solid ${bgColor}`,
        fontWeight: 500,
        fontSize: 13,
        transition: 'all 0.2s',
        width: '100%',
      }}
    >
      {startTime}
    </div>
  );
}
export default Slot;
